import nanoid from 'nanoid/non-secure';

export default {
  props: {
    classInput: {
      type: [String, Array],
      default: '',
    },

    classLabel: {
      type: [String, Array],
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hidden: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
      // Generate random id for pairing the label, if no id is provided
      default: () => nanoid(),
    },

    maxlength: {
      type: Number,
      default: -1,
    },

    minlength: {
      type: Number,
      default: -1,
    },

    name: {
      type: String,
      required: true,
    },

    readonly: {
      type: String,
      default: null,
    },

    required: {
      type: Boolean,
      default: false,
    },

    value: {
      type: String,
      default: '',
    },
  },

  computed: {
    //   inputListeners: function () {
    //     var vm = this
    //     // `Object.assign` merges objects together to form a new object
    //     return {
    //       // We add all the listeners from the parent
    //       ...(this.$listeners),
    //       // Then we can add custom listeners or override the
    //       // behavior of some listeners.
    //       ...({
    //         // This ensures that the component works with v-model
    //         input: function (event) {
    //           vm.$emit('input', event.target.value)
    //         }
    //       })
    //     };
    //  },

    visible() {
      return !this.hidden;
    },
  },
};
